import React from 'react';
import UpcomingTable from '../../components/Table/UpcomingTable';



const Upcoming = () => (
  <div className="content">
    <UpcomingTable />
  </div>
);

export default Upcoming;


// WEBPACK FOOTER //
// ./src/pages/Upcoming/index.js